import React from 'react';

import { RouteProps } from 'react-router';

import Dashboard from './views/Dashboard';
import Inscriptions from './views/Inscriptions';
import InscriptionsDetails from './views/InscriptionsDetails';
import PreInscriptions from './views/PreInscriptions';
import PreInscriptionsAcademies from './views/PreInscriptionsAcademies';
import PreInscriptionsReasons from './views/PreInscriptionsReasons';
import PreInscriptionsSchool from './views/PreInscriptionsSchool';
import PreInscriptionsSummary from './views/PreInscriptionsSummary';
import Sales from './views/Sales';
import SalesDetails from './views/SalesDetails';
import SalesIncome from './views/SalesIncome';
import Settings from './views/Settings';
import Staff from './views/Staff';
import StaffEvolution from './views/StaffEvolution';
import StaffStatistics from './views/StaffStatistics';
import StaffStatus from './views/StaffStatus';
import StaffStatusEvolution from './views/StaffStatusEvolution';
import StaffStudents from './views/StaffStudents';
import StaffTravel from './views/StaffTravel';

type IRoute = RouteProps & { name: string };

const ROUTES_LIST: IRoute[] = [
  {
    path: '/',
    element: <Dashboard />,
    name: 'dashboard',
  },
  {
    path: '/sales',
    element: <Sales />,
    name: 'sales',
  },
  {
    path: '/sales/details',
    element: <SalesDetails />,
    name: 'sales_details',
  },
  {
    path: '/sales/income',
    element: <SalesIncome />,
    name: 'sales_income',
  },
  {
    path: '/staff',
    element: <Staff />,
    name: 'staff',
  },
  {
    path: '/staff/students',
    element: <StaffStudents />,
    name: 'staff_students',
  },
  {
    path: '/staff/travel',
    element: <StaffTravel />,
    name: 'staff_travel',
  },
  {
    path: '/staff/evolution',
    element: <StaffEvolution />,
    name: 'staff_evolution',
  },
  {
    path: '/staff/statistics',
    element: <StaffStatistics />,
    name: 'staff_statistics',
  },
  {
    path: '/staff/status',
    element: <StaffStatus />,
    name: 'status',
  },
  {
    path: '/staff/status/evolution',
    element: <StaffStatusEvolution />,
    name: 'status_evolution',
  },
  {
    path: '/inscriptions',
    element: <Inscriptions />,
    name: 'inscriptions',
  },
  {
    path: '/inscriptions/details',
    element: <InscriptionsDetails />,
    name: 'inscriptions_details',
  },
  {
    path: '/pre-inscriptions',
    element: <PreInscriptions />,
    name: 'pre_inscriptions',
  },
  {
    path: '/pre-inscriptions/summary',
    element: <PreInscriptionsSummary />,
    name: 'pre_inscriptions_summary',
  },
  {
    path: '/pre-inscriptions/academies',
    element: <PreInscriptionsAcademies />,
    name: 'pre_inscriptions_academies',
  },
  {
    path: '/pre-inscriptions/school',
    element: <PreInscriptionsSchool />,
    name: 'pre_inscriptions_school',
  },
  {
    path: '/pre-inscriptions/reasons',
    element: <PreInscriptionsReasons />,
    name: 'pre_inscriptions_reasons',
  },
  {
    path: '/settings',
    element: <Settings />,
    name: 'settings',
  },
];

export default ROUTES_LIST;
